import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPeopleAdd"><Path d="M16 6.5C16 8.70914 14.2091 10.5 12 10.5C9.79086 10.5 8 8.70914 8 6.5C8 4.29086 9.79086 2.5 12 2.5C14.2091 2.5 16 4.29086 16 6.5Z" stroke="currentColor" strokeLinejoin="round"/><Path d="M18.5 15V18.5M18.5 18.5V22M18.5 18.5H15M18.5 18.5H22" stroke="currentColor" strokeLinejoin="round"/><Path d="M16 13.5703C14.8233 12.8896 13.4571 12.5 12 12.5C7.58172 12.5 4 16.0817 4 20.5H13" stroke="currentColor"/></CentralIconBase>;
});

export default IconPeopleAdd;
